module.exports = __webpack_public_path__ + "static/WEDDING E&M-50-17461aaed889f285ee7911b2310e96f5.jpg";